import React, { ReactNode } from 'react'

// textColumnRight has to be of type ReactNode because html tags are not interpreted correctly if it's of type string
export type TableContent = {
    classNameTr?: string
    classNameTdLeft?: string
    classNameTdRight?: string
    textColumnLeft: string
    textColumnRight: ReactNode
}

interface TableRowProps {
    TableRowProps: TableContent
}
export const TableRow: React.FC<TableRowProps> = ({
    TableRowProps: { classNameTr, classNameTdLeft, classNameTdRight, textColumnLeft, textColumnRight },
}) => {
    return (
        <tr className={classNameTr}>
            <td className={classNameTdLeft}>{textColumnLeft}</td>
            <td className={classNameTdRight}>{textColumnRight}</td>
        </tr>
    )
}
